import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthService from '../services/AuthService';
import AuthRoutes from './authRoutes';
import UnAuthRoutes from './unAuthRoutes';
import Layouts from '../components/Layouts';
import { isSet } from '../utils/commonUtils';
import { acl_check } from '../utils/aclUtils';
import NotFound from './NotFoundPage';
import { useSelector } from 'react-redux';
import { activeProfileDetails } from '../store/SessionSlice';
import LoaderIcon from '../components/UI/Icons/LoaderIcon';

const AppRoutes = (props) => {
  // const dispatch = useDispatch();

  const resolveRouteAcl = (routeAcl, aclWhenRole, role) => {
    if (aclWhenRole && role && Object.prototype.hasOwnProperty.call(aclWhenRole, role)) {
      return aclWhenRole[role];
    }
    return routeAcl;
  };

  const PrivateRoute = ({ children, acl, aclWhenRole, path }) => {
    const isAuthenticated = AuthService.isAuthenticated();
    let  hasPermission = true;
    const is2FAComplete = AuthService.is2FAVerified();    
    try{
      const profileDetails = useSelector(activeProfileDetails);
      const {permissions,is_multiple_organization,role,employer_login} = profileDetails;
      const redirectTo= localStorage.getItem('redirectTo');
      const effectiveAcl = resolveRouteAcl(acl, aclWhenRole, role);
      hasPermission =acl_check(profileDetails.permissions,isSet(effectiveAcl,''));
      // console.log('profileDetails -11',profileDetails,acl,hasPermission);
      if(path==='/'){
        let redirectUrl = '/dashboard';
        // let redirectUrl = '/appointments';
       // Check for employer admin first - redirect to dashboard
       if(role === 'employer_admin' || employer_login === true){
         redirectUrl = '/dashboard';
       }
       else if(isSet(is_multiple_organization,false)===true && acl_check(permissions,'organization-list')===true){
         redirectUrl = '/organisation';
       }
       else if(acl_check(permissions,'dashboard-list')===true){
         redirectUrl = '/dashboard';
       }
       else if(acl_check(permissions,'appointment-list')===true){
           redirectUrl = '/appointments';
       }else if(acl_check(permissions,'company-list')===true){
           redirectUrl = '/company';
       }else if(acl_check(permissions,'clinic-list')===true){
           redirectUrl = '/clinics';
       }else if(acl_check(permissions,'employee-list')===true){
           redirectUrl = '/employee';
       }else if(acl_check(permissions,'visits-list')===true){
           redirectUrl = '/visits';
       }else if(acl_check(permissions,'lab-list')===true){
           redirectUrl = '/labs';
       }else if(acl_check(permissions,'user-list')===true){
           redirectUrl = '/users';
       }else if(acl_check(permissions,'role-list')===true){
           redirectUrl = '/roles';
       }
       return <Navigate to={redirectUrl} />;
      }
      else if(isSet(redirectTo,null)!=null && hasPermission==false){
        localStorage.setItem('redirectTo', '');
        return <Navigate to={redirectTo} />;
      }
    }catch(e){

    }
    if (isAuthenticated && is2FAComplete===null) {
       AuthService.logout()
    }
    if (isAuthenticated && is2FAComplete===false) {
      return <Navigate to="/two-factor-authentication" replace />;
    }
    
    return (isAuthenticated && hasPermission) ? children :(!isAuthenticated)?<Navigate to="/login" />:<Navigate to="/unauthorized" />;
  };

  const PublicRoute = ({ children }) => {
    const isAuthenticated = AuthService.isAuthenticated();
    return isAuthenticated ? <Navigate to="/" /> : children;
  };

  const OtherRoute =  ({ children }) => {
    return  children;
  };
  return (
    <Suspense fallback={<div><LoaderIcon/></div>}>
      <Routes>
        {[...AuthRoutes, ...UnAuthRoutes].map((route, index) => {
          const RouteElement = route.element;
          const WrapRoute = route.routeType === 'Auth' ? PrivateRoute : route.routeType === 'Other' ?OtherRoute: PublicRoute;
          const layoutType = route.layoutType;
          const acl = route.acl || [];

          return (
            <Route
              key={index}
              path={route.path}
              exact={route.exact || false}
              element={
                <WrapRoute acl={acl} aclWhenRole={route.aclWhenRole} path={route.path}>
                  <Layouts type={layoutType}>
                    <RouteElement />
                  </Layouts>
                </WrapRoute>
              }
            />
          );
        })}
      <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default (AppRoutes);
